const IdentifierWithVersionRange = {
  type: 'string',
  pattern: '^[a-z_][a-z_\\-\\/\\d]*@((\\d+)(\\.\\d+)*(\\.x)*$|x(\\.x)*)$',
  examples: ['a/b@1.x.x', 'a/b/c@1.0.x', 'a@1.0.0', 'a/b/c@x'],
};

export default IdentifierWithVersionRange;
